// cart-bell-sound.js
// Plays a bell sound only when a NEW product is added to cart (not on remove/quantity change)
// Sound plays 2 seconds after the add-to-cart action

const bellSound = new Audio('https://cdn.shopify.com/s/files/1/1013/9651/3082/files/bell-notification.mp3?v=1786362520');
bellSound.volume = 0.6;

function playCartBell() {
  bellSound.currentTime = 0;
  bellSound.play().catch(() => {});
}

document.addEventListener('shopify:cart:lines-update', function (e) {
  // Only fire when the event originates from the product-add form,
  // not from the cart drawer's quantity/delete controls (cart-items-component)
  const source = e.target;
  const isAddToCart = source && source.closest && source.closest('product-form-component');

  if (isAddToCart) {
    setTimeout(playCartBell, 1500);
  }
}, { capture: true });